var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var normalizeAndEncodeString = function (input) {
    return (input + "")
        .trim()
        .replaceAll(" ", "_")
        .replaceAll("%20", "_")
        .replaceAll("&amp;", "&")
        .replaceAll("&lt;", "<")
        .replaceAll("&gt;", ">")
        .replaceAll("&quot;", "'")
        .toLowerCase();
};
var keysToSkipNormalize = ["currency"];
var normalizeObject = function (inputObj) {
    var normalizedObject = inputObj.constructor === Object ? {} : [];
    Object.keys(inputObj).length &&
        (inputObj.constructor === Object || inputObj.constructor === Array) &&
        Object.keys(inputObj).forEach(function (key) {
            var _a, _b, _c;
            if (((_a = inputObj[key]) === null || _a === void 0 ? void 0 : _a.constructor) === String && !keysToSkipNormalize.includes(key)) {
                normalizedObject[key] = normalizeAndEncodeString(inputObj[key]);
            }
            else if (((_b = inputObj[key]) === null || _b === void 0 ? void 0 : _b.constructor) === Object ||
                ((_c = inputObj[key]) === null || _c === void 0 ? void 0 : _c.constructor) === Array) {
                if (inputObj.constructor === Object) {
                    normalizedObject[key] = normalizeObject(inputObj[key]);
                }
                else {
                    Array.isArray(normalizedObject) &&
                        normalizedObject.push(normalizeObject(inputObj[key]));
                }
            }
            else {
                normalizedObject[key] = inputObj[key];
            }
        });
    return normalizedObject;
};
var dataLayerPush = function (dataLayerObject) {
    window["dataLayer"] = window["dataLayer"] || [];
    window["dataLayer"].push(dataLayerObject);
};
var dataLayerPushEcommerce = function (dataLayerObject) {
    // It's recommended to null out the ecommerce object before dataLayer push
    // https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce#clear-ecommerce
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerObject);
};
function sha256(message) {
    return __awaiter(this, void 0, void 0, function () {
        var msgBuffer, hashBuffer, hashArray, hashHex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    msgBuffer = new TextEncoder().encode(message);
                    return [4 /*yield*/, crypto.subtle.digest("SHA-256", msgBuffer)];
                case 1:
                    hashBuffer = _a.sent();
                    hashArray = Array.from(new Uint8Array(hashBuffer));
                    hashHex = hashArray.map(function (b) { return b.toString(16).padStart(2, "0"); }).join("");
                    return [2 /*return*/, hashHex];
            }
        });
    });
}
function toEhashAsync(email) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!email || typeof email !== "string") {
                return [2 /*return*/, Promise.resolve("")];
            }
            return [2 /*return*/, sha256(email.toLowerCase())];
        });
    });
}
export function delay(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}
export function getEhashCookie() {
    return getCookieVal("SESSehash");
}
export function getSupporterID() {
    var partAuth = getCookieVal("SESSpartauth") ? JSON.parse(getCookieVal("SESSpartauth")) : "";
    return (partAuth === null || partAuth === void 0 ? void 0 : partAuth.supporter_number) || "";
}
export function getCookieVal(name, decodeVal) {
    if (decodeVal === void 0) { decodeVal = true; }
    if (!window.document.cookie) {
        return "";
    }
    var reCookieName = new RegExp("".concat(name, "=([^;]+)")).exec(window.document.cookie);
    var cookieVal = reCookieName && reCookieName[1] || "";
    if (decodeVal === true) {
        return decodeURIComponent(cookieVal);
    }
    return cookieVal;
}
export var SPONSORSHIP_PRODUCT_SKU = "S1000001";
export var CHOSEN_PRODUCT_SKU = "S1000002";
var isChosenProduct = function (productId) {
    return productId === CHOSEN_PRODUCT_SKU;
};
export var SPONSORSHIP_ITEM_ID = "380";
var isSponsorshipProduct = function (productItemId) {
    return productItemId === SPONSORSHIP_ITEM_ID;
};
export { normalizeAndEncodeString, dataLayerPush, normalizeObject, sha256, toEhashAsync, isChosenProduct, isSponsorshipProduct, dataLayerPushEcommerce };
